<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">FAQs</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <a href="/">Pages</a>
                            </li>
                            <li class="breadcrumb-item active">FAQs</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <!-- end page title -->

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Add Faqs</h4>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="saveFaq">
                            <div class="row">
                                <div class="mb-3 col-6">
                                    <label for="question" class="form-label">Title</label>
                                    <input class="form-control" type="text" id="question"
                                           placeholder="e.g What is BuyLetLive?" v-model="faq.title">
                                </div>
                                <div class="mb-3 col-12">
                                    <label class="form-label">Purpose</label>
                                    <div  class="d-flex">
                                        <div class="form-check form-switch mr-2">
                                            <input v-model="faq.purpose"
                                                   id="general_faq"
                                                   class="form-check-input"
                                                   type="checkbox"
                                                   value="general"
                                            />
                                            <label class="form-check-label ms-2" for="is_referral_enabled">
                                                General
                                            </label>
                                        </div>
                                        <div class="form-check form-switch mr-2">
                                            <input v-model="faq.purpose"
                                                   id="drivers_faq"
                                                   class="form-check-input"
                                                   type="checkbox"
                                                   value="drivers"
                                            />
                                            <label class="form-check-label ms-2" for="is_referral_enabled">
                                                Drivers
                                            </label>
                                        </div>
                                        <div class="form-check form-switch mr-2">
                                            <input v-model="faq.purpose"
                                                   id="users_faq"
                                                   class="form-check-input"
                                                   type="checkbox"
                                                   value="users"
                                            />
                                            <label class="form-check-label ms-2" for="is_referral_enabled">
                                                Users
                                            </label>
                                        </div>
                                        <div class="form-check form-switch mr-2">
                                            <input v-model="faq.purpose"
                                                   id="fleet_managers_faq"
                                                   class="form-check-input"
                                                   type="checkbox"
                                                   value="fleet_managers"
                                            />
                                            <label class="form-check-label ms-2" for="is_referral_enabled">
                                                Fleet Managers
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3 col-12">
                                    <label class="form-label">Description</label>
                                    <vue-editor v-model="faq.description"></vue-editor>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-xs-12">
                                    <button class="btn btn-primary" :disabled="saving">
                                        {{ isEditing ? 'Update' : 'Save' }}
                                        <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- end col -->
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import {VueEditor} from "vue2-editor";

export default {
    metaInfo: {title: 'Add FAQs'},
    props: ['faqs', 'isEditing'],
    layout: Layout,
    components: {
        VueEditor,
    },
    data: () => ({
        faq: {
            purpose: [],
        },
        saving: false,
    }),
    methods: {
        async saveFaq() {
            try {
                if (this.isEditing) {
                    await this.$inertia.put(route('admin.cms.faqs.update', this.faq.id), {...this.faq});
                } else {
                    await this.$inertia.post(route('admin.cms.faqs.store'), this.faq);
                }
                this.saving = false
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        }
    },
    mounted() {
        if (this.isEditing) {
            this.faq = this.faqs
        }
    }
}
</script>

<style scoped>

</style>
